import { render } from "./RecordCard.vue?vue&type=template&id=579681e1&scoped=true"
import script from "./RecordCard.vue?vue&type=script&lang=js"
export * from "./RecordCard.vue?vue&type=script&lang=js"

import "./RecordCard.vue?vue&type=style&index=0&id=579681e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579681e1"]])

export default __exports__